import script from "./PersonalInformationView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PersonalInformationView.vue?vue&type=script&lang=ts&setup=true"

import "./PersonalInformationView.vue?vue&type=style&index=0&id=a4d161f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4d161f8"]])

export default __exports__